import {useAppDataStore} from "@/mobx/appDataStore.jsx";
import {Button, TextField} from "aria";
import {useFormik} from "formik";
import {useEffect, useMemo, useState} from "react";

export default function Config(props) {
  const appDataStore = useAppDataStore()
  const formik = useFormik({
    initialValues: {
      oldPassword: '',
      newPassword1: '',
      newPassword2: '',
    },
    onSubmit: async (values) => {
      try {
        const res = await appDataStore.post('/auth/changePassword', values)
        alert('La contraseña se ha cambiado con éxito')
        formik.resetForm()
      } catch (err) {
        alert(err.message)
      }

    }
  })
  return (
    <>
      <div className="p-2 max-w-7xl mx-auto text-black fill-gray-800">
        <TextField
          name={'oldPassword'}
          type={'password'}
          label={'Contraseña anterior'}
          onChange={(e) => formik.setFieldValue('oldPassword', e)}
          onBlur={formik.handleBlur}
          value={formik.values.oldPassword}
        />
        <TextField
          name={'newPassword1'}
          type={'password'}
          label={'Nueva Contraseña'}
          onChange={(e) => formik.setFieldValue('newPassword1', e)}
          onBlur={formik.handleBlur}
          value={formik.values.newPassword1}
        />
        <TextField
          name={'newPassword2'}
          type={'password'}
          label={'Repetir nueva contraseña'}
          onChange={(e) => formik.setFieldValue('newPassword2', e)}
          onBlur={formik.handleBlur}
          value={formik.values.newPassword2}
        />

        <p className={'mt-3'}></p>
        <Button onClick={formik.submitForm} isDisabled={formik.isSubmitting}>Guardar</Button>
      </div>
    </>
  )
}